<template>
	<!-- 系统目录 西成药品 -->
	<div class="MedicenCata">
		<!--  描述  -->
		<div class="header">
			<div class="header-icon">
				<i class="el-icon-jkda"
					style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;background-color: #409EFF;color: #fff;"></i>
				<span style="font-size: 12px;font-weight:400;margin-left: 12px;">客户档案</span>
			</div>
		</div>
		<!-- main -->
		<div class="main">
			<!-- left -->
			<div class="main-left">
				<!-- tree -->
				<el-tree 
				:data="elTree" 
				:props="defaultProps"
				node-key="label"
				:default-expanded-keys="['全部']"
				accordion 
				@node-click="handleNodeClick"
				class="custom-tree"
				>
					<span class="custom-tree-node" slot-scope="{ node, data }" style="font-size: 12px;">
						<span :name="node.label">
							<i v-if="!data.children"
							:class="node.expanded ? 'el-icon-openFile' : 'el-icon-closeFiles'"></i>
							<i v-else class="el-icon-openFile"></i>{{ node.label }}
						</span>
					</span>
				</el-tree>
			</div>
			<!-- right -->
			<div class="main-right">
				<!-- tit -->
				<div class="main-icon">
					<div class="main-icon-a">
						<i :class="iconComes" style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;;background-color: #5a5a5a;color: #fff;"></i>
						<span style="font-size: 12px;font-weight:bold;margin-left: 12px;color: #606266;">{{ CatalogueName }}</span>
					</div>
					<!-- btn1 -->
					<div class="main-icon-b">
						<span style="font-size: 12px;color: #606266;font-weight: bold;">状态：</span>
						<el-dropdown @command="handleCommand" trigger="click">
							<span class="el-dropdown-link">{{ DropDownedName }}<i class="el-icon-down"></i></span>
							<el-dropdown-menu slot="dropdown">
							  <el-dropdown-item command="a">可用</el-dropdown-item>
							  <el-dropdown-item command="b">禁用</el-dropdown-item>
							  <el-dropdown-item command="c" divided>全部</el-dropdown-item>
							</el-dropdown-menu>
					    </el-dropdown>
					</div>
					<!-- btn2 -->
					<div class="main-icon-c">
						<span style="font-size: 12px;color: #606266;font-weight: bold;display: inline-block;width: 68px;">关键字：</span>
						<el-input size="mini" placeholder="编码、名称、拼音简码" suffix-icon="el-icon-key" v-model="searchValue"></el-input>
					</div>
					<!-- btn3 -->
					<div class="main-icon-c">
						<el-button v-for="(v,i) in headerBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon" size="mini" @click="handClick(i)">{{ v.title }}</el-button>
					</div>
				</div>
				<!-- add data -->
				<!-- messagesBox -->
				<div class="addmessagesBox">
				</div>
				<!-- table -->
				<div class="table">
					<el-table :data="tableData" border @row-dblclick="handledbRow"  :style="{ width: windowWidth + 'px' }">
						<el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop" :label="col.name" :width="columnWidth(col, tableData)"></el-table-column>
						<!-- fixed -->
						<el-table-column fixed="left" label="行号" type="index"></el-table-column>
						<!-- edit -->
						<el-table-column fixed="right" label="操作" width="148">
						      <template slot-scope="scope">
								  <div class="editbox" style="text-align: center;">
									<el-button type="primary" @click="handleClickEdit(scope.row)" size="mini">编辑</el-button>
									<el-button type="danger" @click="handleDelete(scope.row.id)" size="mini">删除</el-button>
								  </div>
						      </template>
						</el-table-column>
					</el-table>
				</div>
				<!-- 分页 -->
				<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="pageNum"
				:page-sizes="[5, 10, 20]"
				:page-size="pageSize"
				:total="totalSize"
				layout="total, sizes, prev, pager, next, jumper"
				background
				>
				</el-pagination>
			</div>
		</div>
		<!-- feet -->
		<div class="feet">
			<!-- messagesBox -->
			<div class="messagesBox">
				<el-dialog  title="新增" :visible.sync="addfilesVisible" width="66%" :before-close="handleClose">
				<div class="aform">
					<el-tabs v-model="activeName" type="card" @tab-click="handleClickTabs">
					    <el-tab-pane label="基本信息" name="first">
							<!-- 表单 -->
							<el-form ref="form" :model="addForm" label-width="88px" size="mini">
								<el-row :gutter="20">
								  <el-col :span="v.spanRows" type="flex" v-for="(v,i) in formType" :key="i">
									  <!-- input -->
									  <el-form-item v-if="v.type == 'input'" :label="v.label">
										<el-input :suffix-icon='v.prefix' v-model="$data.addForm[v.modelValue]" :placeholder="v.placeholder" @blur='OpenIconsFocus(v,i)'></el-input>
									  </el-form-item>
									  <!-- checked -->
									  <el-form-item v-if="v.type == 'checked'" :label="v.label">
										<el-checkbox v-model="$data.addForm[v.modelValue]"></el-checkbox>
									  </el-form-item>
									  <!-- select -->
									  <el-form-item v-if="v.type == 'select'" :label="v.label">
										<el-select v-model="$data.addForm[v.modelValue]" filterable :placeholder="v.placeholder" @focus="sname(v,i)" @change="scname">
											<el-option v-for="item in $data[v.op]" :key="item.pe" :label="item.label" :value="item" filterable> 
											<span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
										</el-select>
									  </el-form-item>
									  <!-- input -->
									  <el-form-item v-if="v.type == 'textarea'" :label="v.label">
										<el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="$data.addForm[v.modelValue]"></el-input>
									  </el-form-item>
								  </el-col>
								</el-row>
							</el-form>
						</el-tab-pane>
					    <el-tab-pane label="过敏记录" name="second">过敏记录</el-tab-pane>
					    <el-tab-pane label="扩展信息" name="third">扩展信息</el-tab-pane>
					</el-tabs>

				</div>	
				  <span slot="footer" class="dialog-footer">
				    <el-button type="primary" @click="addNewData" size="mini">确 定</el-button>
				    <el-button @click="addMenuDialog = false" size="mini">取 消</el-button>
				  </span>
				</el-dialog>
			</div>
		</div>

	</div>
</template>/

<script>
	// selfs / js
	import Chinese from "@/external/PY.js";
	import Pinyin from "@/external/pinyin.js";
	import AccType from './AddType.js'
	import editType from './editType.js'
	// import MedicenCata from '../../external/MedicenCata.js'
	// 接口
	// import {} from "@/api/systemCatalogue/WinningTheBidgrades.js";
	export default {
		components: {
			// MedicenCata
		},
		data() {
			return {
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				// str
				activeName: 'first',
				watch:'查看',
				searchValue:'',
				windowWidth:'',
				toCodeNum:'0000',//拼接自增 导零
				iconHandleClick:'el-icon-plus',
				CatalogueName:'客户档案',
				DropDownedName:'可用',
				typeValue:'',
				YNuseVaule:'可用',
				nowDateTimeValue:'',
				iconComes:'el-icon-jkda',
				operatingTime:'',
				// boolean
				disabled:true,
				noEidt:true,
				formdisabled:true,
				loading:false,
				dialogVisible:false,	//此乃查看/编辑控制
				addfilesVisible:true, //此乃新增控制
				// number
				dataIndex: 0,
				CodeNumber:0,
				pageNum: 1, //当前页currentPage
				pageSize: 8,
				totalSize: 10, //总条数
				/* obj */
				// 新增
				addForm: {
				  	code: "",
				  	gradeCode: "001",
				  	label: "",
				  	operatingTime: "",
				  	operator: "",
				  	remark: "",
				  	status: "",
				  	typeName: ""
				},
				// arr
				data: [],
				oop:[],
				formType:[],
				userInfo: [],
				watchData: [],
				YNuse:[{ id:1,label:'可用',value:'1'},{ id:2,label:'禁用',value:'2'}],
				// title右侧按钮
				headerBtn:[
				 { refesh:"refesh", title:"刷新", type:"", icon:"el-icon-refresh" },
				 { senior:"senior", title:"高级", type:"", icon:"" },
				 { add:"add", title:"新增", type:"warning" },
				],
				// title右侧按钮
				tableRows:[
					{ name:"序号", prop:"code", nz:"nz" },{ name:"隶属机构", prop:"label", type:"" },{ name:"健康ID", prop:"healthID", type:"" },
					{ name:"有效状态", prop:"status", type:""},{ name:"身份证号", prop:"IdCard", type:"" },{ name:"姓名", prop:"operator", type:"" },
					{ name:"性别", prop:"sex", nz:"nz" },{ name:"出生日期", prop:"operatingTime", type:"" },{ name:"民族", prop:"remark", type:"" },
					{ name:"联系电话", prop:"tel", type:"" },{ name:"联系地址", prop:"address", type:"" },{ name:"出生日期", prop:"operatingTime", type:"" },
					{ name:"人员类型", prop:"pType", type:"" },{ name:"操作员", prop:"operater", type:"" },{ name:"操作时间", prop:"operatingTime", type:"" },
					{ name:"客户单位", prop:"address", type:"" }
				],
				elTree:[
					{
						label: '全部',
						path:'',
						title:'',
						icon:'el-icon-news',
						children: [
							{
								label: '居民档案',
								path:'',
								title:'居民档案',
								icon:'el-icon-xxj',
							}, 
							{
								label: '职工档案',
								path:'',
								title:'职工档案',
								icon:'el-icon-shenjingxitong',
							},
							{
								label: '微信档案',
								path:'',
								title:'微信档案',
								icon:'el-icon-xxj',
							}, 
							{
								label: '单位档案',
								path:'',
								title:'单位档案',
								icon:'el-icon-xxj',
							}, 
						]
					}
				],
				tableData: [
					{ num:'1', code:'W000000001',sex:'男',pType:'神',tel:'12345678910',address:'朱雀赵国', label: '逆尘界',healthID:'XN666',IdCard:'WL123666888', status: '可用', nz: '否',operater:'耳根',operatingTime:'2024-12-07 05：36：48',operator:'王林',remark:'王麻子。被称为“王麻子”主要因：杀人如麻‌：王林为了争夺资源和提升自己的实力，经常会有杀戮行为。被其他人所畏惧，给他取了一个“杀人如麻”的外号，就演变成了“王麻子”。' },
					{ num:'2', code:'S000000002',sex:'男',pType:'天帝',tel:'12345678910',address:'下界石村', label: '下界石村',healthID:'WM666',IdCard:'SH6688999', status: '可用', nz: '否',operater:'辰东',operatingTime:'2024-12-07 05：36：48',operator:'石昊',remark:'荒天帝。天资万古无双，为应劫而至，为修道而生，一生中极致辉煌，造就无尽传说，七神下界，石昊战死，荒应劫而生。‘谁在称无敌？哪个敢言不败？’。杀到世间无人敢称尊，一人横推异域无人敌，他化万古灭尸骸仙帝，一剑断万古造就完美世界……他的一生无敌灿烂但又孤独冰冷，他就是天帝！荒！' },
					{ num:'3', code:'Y000000003',sex:'男',pType:'天帝',tel:'12345678910',address:'地球北京', label: '北京',healthID:'YF666',IdCard:'YF6688999', status: '可用', nz: '否',operater:'辰东',operatingTime:'2024-12-07 14：16：48',operator:'叶凡',remark:'叶天帝。荒古圣体，历险禁地，习得源术，斗圣地世家，战太古生物，闯星空古路，阻黑暗动乱，重立天庭。最终以力证道，打破圣体不可成帝的诅咒，成就天帝果位，平定六大禁区，取得万族认可，宇宙共尊。' },
					{ num:'4', code:'L000000003',sex:'男',pType:'魔',tel:'12345678910',address:'阴死之地', label: '‌塑冥',healthID:'SM123666888',IdCard:'SM', status: '可用', nz: '否',operater:'耳根',operatingTime:'2024-12-08 08：56：13',operator:'苏铭',remark:'苏铭,宿命,塑冥,第五真界塑冥族族人，苏战之子，生来夭折，第五真界被破时被苏轩衣利用，导致其身魂分离。仙族攻陷大虞，二代蛮神被分尸，苏铭尸体被帝天所获，发现其尸体中孕育有魂，将其魂沉沦在蛮族大地，以其塑冥天赋实现自己的计划。随着修为的提升，发觉记忆中的层层虚假，自己命运被人操控。为了重新掌握自己的命运，苏铭踏上了这条修命之路。为蛮族四代蛮神，夺厄苍分身，具备灭生之种，一生曲折，造化无尽。' },
					{ num:'5', code:'J000000004',sex:'男',pType:'妖',tel:'12345678910',address:'山海界', label: '‌山海界',healthID:'JZ888',IdCard:'WL', status: '可用', nz: '否',operater:'耳根',operatingTime:'2024-12-08 10：36：42',operator:'孟浩',remark:'方浩，本是东胜星方家嫡长孙，后因七岁劫被其父母带到南天星抚养，在父母离开后独自生活在赵国，本为书生，后因机缘巧合被许清带入靠山宗，成为了封妖一脉的第九代传人，从此以后踏入我命如妖欲封天的修行之路。' },	
					{ num:'6', code:'J000000004',sex:'男',pType:'鬼',tel:'12345678910',address:'魁墓灵溪', label: '‌魁墓灵溪',healthID:'BXC888',IdCard:'BXC', status: '可用', nz: '否',operater:'耳根',operatingTime:'2024-12-08 10：36：42',operator:'白小纯',remark:'青年模样，白白净净，十分无害，身着一身青衫，一脸乖巧，相貌俊朗性格,因从小父母双亡，一心追求长生不死。平时吊儿郎当胆小怕死，但真拼起来很猛，拼起命来很疯，极在意身边人，为了在乎的人可以不顾自身安危，喜好放嘴炮并以此沾沾自喜，赤子之心，心智犹如孩童似乎永远不会成熟似的，行事被动，很少占据主动权' },
				],
				 pickerOptions: {
				  shortcuts: [{
					text: '今天',
					onClick(picker) {
					  picker.$emit('pick', new Date());
					}
				  }, {
					text: '昨天',
					onClick(picker) {
					  const date = new Date();
					  date.setTime(date.getTime() - 3600 * 1000 * 24);
					  picker.$emit('pick', date);
					}
				  }, {
					text: '一周前',
					onClick(picker) {
					  const date = new Date();
					  date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
					  picker.$emit('pick', date);
					}
				  }]
				},
			};
		},
		computed: {
		    // 格式化数字，确保4个0后的数字自增时不会出现前导零
		    formattedNumber() {
				return '00000' + this.toCodeNum.toString().slice(1);
		    },
		  },
		mounted() {
			this.dataIndex ++
			this.loadData();
			this.nowDateTime();
			
			this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
			this.addForm.operator = this.userInfo.userName

			//获取动态盒子宽度，实时赋值给右侧 => this.$refs.mainRight.offsetWidth;
			this.$nextTick(()=>{
				this.updateWindowWidth();
				window.addEventListener('resize', this.updateWindowWidth);
			})
			// 新增表单自定义格式
			this.formType = AccType.map(function(v) {
				return v
			})
		},
		methods: {
			/*
				about tree
			*/
			handleNodeClick(data,e) {
				this.CatalogueName = data.title
				this.iconComes = 'el-icon-' + this.makePy(data.label)
				console.log(this.iconComes);
				this.loadData();
			},

			/*
				about table
			*/
		   
		   // 数据源 毒麻类型
		    async loadData(){
			 
		    },
			scname(v){
				
			},
			// tabs
			handleClickTabs(){
				
			},
		   // col 里面包含了表头字段和名称，list 是表格数据
		       columnWidth(col, list) {
		         let prop = col.prop,lab = col.lab;
		         let width = 40; // 设定一个最小值
		         let maxlenStr = ""; // 最长字符串
		         for (let info of list) {
		           if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
		         }
		         width = Math.max(width, len(lab), len(maxlenStr));
		         // 表格自带的内边距(20px) 自调
		         return width + 12; // 这里加了 12px
		         function len(str) {
		           // 实际分配长度可根据需要自行调整
		           let length = 8;
		           for (const char of str + "") {
		             // 英文小写字符 8px
		             if ("a" <= char && char <= "z") length += 8;
		             // 英文大写字符 8px
		             else if ("A" <= char && char <= "Z") length += 8;
		             // 中文字符 28px
		             else if (char >= "\u4e00" && char <= "\u9fa5") length += 8;
		             // 其他 8px
		             else length += 12;
		           }
		           return length;
		         }
		       },
			// see table
			handleDelete(id){
				this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}).then(async () => {
						let res = await deleteByPoison(id);
						let { code, message } = res;
						if (res.code === 200) {
							this.$message({
								type: "success",
								message: message,
							});
							this.loadData(); //更新数据驱动
						} else {
							this.$message.error(message);
						}
					})
					.catch(() => {
						this.$message({
							type: "fail",
							message: '失败',
						});
					});
			},
			// edit table
			handleClickEdit(val){
				this.watch = '编辑';
				this.form = val; this.dialogVisible = true;this.noEidt = true,
				this.formdisabled = false;
			},
			// 编辑保存
			async saveEditData(){
				console.log(this.form);
				let rs = await updatePoisonAnesthesia(this.form);
				let { code,message } = rs;
				if (code === 200) {
					this.$message({
						type: 'success',
						message: '修改成功！',
					});
					this.loadData(); //更新驱动
					this.dialogVisible = false;
				} else {
					this.$message.error('失败！')
				}
			},
			//新增保存
			addNewData(){
				// let res = await addPoisonAnesthesia(this.addForm)
				console.log(this.addForm);
				//触发验证表单
				this.$refs.addForm.validate(async(valid) => {
				  if(valid){
				    //验证通过
				    // console.log('submit');
				    let res = await addPoisonAnesthesia(this.addForm)
				    console.log(res);
					if (res.code === 200){
					this.$message({
						message:res.message,
						type:"success"
					});
					this.loadData(); //更新数据驱动
					}else{
					  //验证失败
					  console.log('失败');
					}
				}
				});
			},
			// input 
			inputLabel(){
				this.addForm.code = this.makePy(this.addForm.label).toLocaleUpperCase().slice(0,1) + this.formattedNumber + this.CodeNumber;//编码
				this.addForm.textSpell = this.makePy(this.addForm.label).toLocaleUpperCase();//拼音简码
			},
			handleClose(done) {
				this.$confirm('确认关闭？')
				  .then(_ => {
					this.formdisabled = true;
					done();
				  })
				  .catch(_ => {
					this.formdisabled = this.formdisabled;
				  });
			},
			// db events
			handledbRow(row, column, event){
				if(row){ this.form = row; this.dialogVisible = true } else { console.log('fail'); }
				// console.log(this.form);
				this.formdisabled = true
				this.form.textSpell = this.makePy(this.form.label).toLocaleUpperCase()
				// console.log(this.form.textSpell);
			},

			// 步骤
			handClick(i) {
				// i event
				switch (i) {
					case 0:
						// 处理索引0的逻辑
						this.loading = true;
						if(this.searchValue == ''){
							setTimeout(() => {
								this.$message.error('关键字不能为空！');
								this.loading = false;		
							}, 1500)
						}else{
							this.$confirm('敬请期待')
							.then(_ => {})
							.catch(_ => {});
						}
						break;
					case 1:
						// 处理索引1的逻辑
						this.$confirm('敬请期待')
							.then(_ => {})
							.catch(_ => {});
						break;
					case 2:
						// 处理索引2的逻辑 => 新增
						this.addfilesVisible = true
						break;
				}
			},
			handleCommand(command) {
			  // console.log(command);
			  // 根据 command 值执行相应的逻辑
			  switch (command) {
				case 'a':
				  // 处理a的逻辑
				  console.log('执行A逻辑');
				  this.DropDownedName = '可用'
				  break;
				case 'b':
				  // 处理b的逻辑
				  console.log('执行B逻辑');
				  this.DropDownedName = '禁用'
				  break;
				case 'c':
				  // 处理b的逻辑
				  this.DropDownedName = '全部'
				  break;
				// ... 其他 case
			  }
			},
			//分页
			//每页条数改变触发
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.pageNum = val;
			},
			//当前条数改变触发
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageNum = val;
			},
			// 实时宽度
			updateWindowWidth() {
			    this.windowWidth = window.innerWidth - 368;
			},
			// 系统当前日期时间
			nowDateTime(){
				const now = new Date(); //创建时间日期对象
				const year = now.getFullYear(); //年
				const month = now.getMonth() + 1; //月份是从0开始的
				const day = now.getDate(); //日
				const hours = now.getHours(); //小时
				const minutes = now.getMinutes(); //分钟
				const seconds = now.getSeconds(); //秒
				const currentDate = `${year}-${month}-${day}`.replace(/-/g, '') //替换操作
				this.nowDateTimeValue = `${year}-${month}-${day}` + ` ` + `${hours}:${minutes}:${seconds}`
				// this.datetimesinglend = 
				// 将字符串转换为Date对象
				// console.log(this.nowDateTimeValue);
			}
			
		}
	}
</script>

<style lang="less" scoped>
	// 穿透
	/deep/ .el-dialog__header{
		padding: 12px;
		background-color: #007bb0;
	}
	/deep/ .el-dialog__title{
		font-size: 12px;
		color: #fff;
	}
	/deep/ .el-dialog__headerbtn .el-dialog__close{
		color: #fff;
	}
	/deep/ .el-input.is-disabled .el-input__inner{
		color: #87898f;
	}
	/deep/ .el-textarea.is-disabled .el-textarea__inner{
		color: #87898f;
	}
	/deep/ .el-icon-arrow-left:before {
	    content: "\e67d";
	    font-size: 18px;
	}
	/deep/ .el-dropdown-menu__item{
		font-size: 12px;
	}
	/deep/ .el-dialog__body{
		padding: 30px;
	}
	/deep/ .el-descriptions{
		font-size: 12px !important;
	}
	/deep/ .el-descriptions-item__container{
		display: flex !important;
		// align-items: center !important;
		padding-top: 12px !important;
	}
	/deep/ .el-descriptions-item__label:not(.is-bordered-label){
		padding-left: 0;
		width: 66px;
		display: flex;
		justify-content: right;
	}
	/deep/ .el-color-picker__icon, .el-input, .el-textarea{
		width: 100%;
	}
	// content
	.MedicenCata {
		height: 100%;
		width: 100%;
		// header
		.header {
			display: flex;
			flex-direction: row;
			align-items: center;
			height: 40px;
			background-color: #efefef;
			padding: 4px;

			// justify-content: space-evenly;
			// icon
			.header-icon {
				display: flex;
				align-items: center;
			}

		}

		// main
		.main {
			width: 100%;
			display: flex;
			justify-content: left;
			// height: 473px; /* 设置父容器的高度 */
			overflow-y: auto; /* 当内容超出容器高度时显示垂直滚动条 */
			// left
			.main-left {
				.custom-tree {
				  max-height: 100%; /* 设置树形菜单的最大高度为父容器的100% */
				  overflow-y: auto; /* 当内容超出设定高度时显示滚动条 */
				}
				/deep/ .el-tree-node__content {
					height: 40px;
					padding-left: 0 !important;
				}
				/deep/ .el-tree-node__label{
					font-size: 12px;
				}
				width: 168px;
				height: 100%;
			}

			// right
			.main-right {
				width: 90%;
				height: 100%;
				// alert
				.addmessagesBox{
					.tabs{
						/deep/ .el-select>.el-input{
							width: 172px;
						}
						/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
							width: 172px;
						}
						/deep/ .el-form-item__content{
							display: flex;
							
							span{
								font-size: 12px;
							}
						}
						.oneLine{
							width: 524px;
							// background-color: indianred;
						}
					}
					/deep/ .el-dialog__title{
						font-size: 12px;
					}
					/deep/ .el-table{
						font-size: 12px;
					}
				}
				// icon
				.main-icon {
					display: flex;
					align-items: center;
					padding: 12px;
					line-height: 40px;
					.main-icon-a{
						// width: 240px;
						// background-color: #00557f;
					}
					.main-icon-b{
						margin-left: 28px;
						/deep/ .el-dropdown{
							font-size: 12px;
							cursor: pointer;
						}
						/deep/ .el-dropdown:hover {
							font-weight: bold;
							color: #66b1ff;
						}
						/deep/ .el-icon--right{
							// background-color: #66b1ff;
						}
						/deep/ .el-popper[x-placement^=bottom]{
							margin-top: 0;
						}
					}
					// c
					.main-icon-c{
						display: flex;
						margin-left: 28px;
						/deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b]{
							width: 80%;
						}
					}
				}
				// table
				/deep/ .el-table .cell{
					font-size: 12px;
					text-align: center;
				}

				/deep/ .el-table td.el-table__cell div :first-child{
					text-align: center;
				}
				/deep/ .el-table td.el-table__cell div{
					text-align: left;
					overflow: hidden;
					white-space: normal;
					word-break: break-all;
				}
				
				.table{
					padding: 12px;
				}
			}
		}

		// feet
		.feet {

			// alert
			.messagesBox{
				.tabs{
					
					/deep/ .el-form-item__content{
						display: flex;
						
						span{
							font-size: 12px;
						}
					}
					.oneLine{
						width: 524px;
						// background-color: indianred;
					}
				}
				/deep/ .el-dialog__title{
					font-size: 12px;
				}
				/deep/ .el-table{
					font-size: 12px;
				}
			}
		}

	}
</style>